import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import useViewPort from "../../../hook/useViewPort";
import ImageType4 from "../../molecules/image-type-4";
import { currentUser } from "@quintype/bridgekeeper-js";
import { userFavouritesApi } from "../../utils/user-favourites-api";
import "./user-media-favourites.m.css";
import { getCollections } from "../../../../api/utils";
import { useSelector } from "react-redux";
import { ResponsiveImage } from "@quintype/components";
import axios from "axios";

const UserMediaFavourites = ({ qtConfig, initAccessType, getSubscriptionForUser, cancelSubscription, isATGlobal, member }) => {
  const { viewports } = useViewPort();
  const [userId, setUserId] = useState(null);
  const [yesterdayMedia, setYesterdayMedia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const defaultImgState = useSelector((state) => get(state, ["qt", "config"]));
  const defaultImage = get(defaultImgState, ["publisher-attributes", "defaultImageKey"], "");
  const arrSections = qtConfig?.sections ?? [];

  useEffect(() => {
    const fetchUserId = async () => {
      try {
        const currentUserResp = await currentUser();
        const userId = currentUserResp?.user?.id || null;
        setUserId(userId);
      } catch (error) {
        console.error("Error fetching user id:", error);
      }
    };
    fetchUserId();
  }, []);

  const loadUserFavData = async (userId) => {
    try {
      const favourites = await userFavouritesApi(userId);
      return Array.isArray(favourites) ? favourites : [];
    } catch (error) {
      console.error("Error fetching user favourites:", error);
      return [];
    }
  };

  useEffect(() => {
    if (!userId) return;

    const fetchData = async () => {
      const arrSectionCollectionDetails = await loadUserFavData(userId);
      setYesterdayMedia(arrSectionCollectionDetails);
    };

    const memberID = get(member, ["id"], "");
    if (memberID) {
      initAccessType(() => {
        getSubscriptionForUser()
          .then((res) => {
            const hasActiveSubs = Array.isArray(res?.subscriptions)
              ? res.subscriptions.some(sub => sub.status === "active")
              : false;

            if (hasActiveSubs) {
              fetchData();
            }
          })
          .catch((err) => {
            console.error("Error occurred inside profile page --->", err);
          });
      });
    }
  }, [userId]);

  const handleRemoveFav = async (assetId) => {
    try {
      if (!userId) return;

      const response = await axios.post("/user-favourites/delete", { user_id: userId, asset_id:assetId });
      const arrSectionCollectionDetails = await loadUserFavData(userId);
      setYesterdayMedia(arrSectionCollectionDetails);
    } catch (error) {
      console.error("Error deleting favourite:", error);
    }
  };

  return (
    Array.isArray(yesterdayMedia) && yesterdayMedia.length > 0 &&
    <div styleName="container">
      <div styleName="history-headline" className={viewports ? viewports : ""}>
        <h2>Suosikit</h2>
      </div>

      <div styleName="image-grid" className={viewports ? viewports : ""}>
        {yesterdayMedia.map((objFavItem, index) => {
          if (!objFavItem?.id) {return;}
          let contentType = objFavItem?.metadata["content-type"]?.[0]?.name;
          let behindPaywall = objFavItem?.metadata["behind-paywall"]?.[0]?.name || null;
          let slug = objFavItem?.metadata?.["slug"];

          const collectionHeroImgS3Key = objFavItem?.metadata?.["cover-image"]?.["cover-image-s3-key"] ?? defaultImage;
          if (!collectionHeroImgS3Key) return null;

          return (
            <div key={objFavItem?.metadata?.id || index} id={objFavItem?.metadata?.id} styleName="image-container" className={viewports ? viewports : ""}>
              <Link href={slug}>
                <div styleName="responsive-img">
                  {collectionHeroImgS3Key && collectionHeroImgS3Key && (
                    <figure>
                      <ResponsiveImage
                        aspectRatio={[16, 9]}
                        defaultWidth={480}
                        widths={[250, 480, 640]}
                        slug={collectionHeroImgS3Key}
                        key={index}
                        alt={collectionHeroImgS3Key}
                      />
                    </figure>
                  )}
                  {/* Delete icon on bottom-right */}
                  <div styleName="del-fav-icon-wrapper">
                    <button styleName="symbol-selected" onClick={(e) => {e.preventDefault();e.stopPropagation();handleRemoveFav(objFavItem?.metadata?.id);}}>
                      <img alt="video-logo" src="/icons/favorites-symbol-added-white.svg" styleName="fav-icon" />
                    </button>
                  </div>
                  {/* Subscription icon on top-left */}
                  {
                    behindPaywall ==="Kyllä" &&
                    (<div styleName="subscription-wrapper">
                      <img
                        alt="subscription-icon"
                        src="/icons/under-subcription.svg"
                        styleName="subscription-image"
                      />
                    </div>)
                  }
                  {/* Audio/Video icon on top-right */}
                  {
                    contentType &&
                    (<div styleName="audio-video-wrapper">
                      {contentType === "Audio" && (
                        <img alt="audio-logo" src="/icons/podcast-icon-white.svg" styleName="custom-img-icon" />
                      )}
                      {contentType === "Video" && (
                        <img alt="video-logo" src="/icons/video-icon-white.svg" styleName="custom-img-icon" />
                      )}
                    </div>)
                  }
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UserMediaFavourites;
